module.exports = __webpack_public_path__ + "img/073401.2e23f2bc.png";